import React from 'react';

// Custom SVG Icons for Product Categories
export const FlowerIcon = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2Z" fill={color}/>
    <path d="M12 18C13.1 18 14 18.9 14 20C14 21.1 13.1 22 12 22C10.9 22 10 21.1 10 20C10 18.9 10.9 18 12 18Z" fill={color}/>
    <path d="M2 12C2 10.9 2.9 10 4 10C5.1 10 6 10.9 6 12C6 13.1 5.1 14 4 14C2.9 14 2 13.1 2 12Z" fill={color}/>
    <path d="M18 12C18 10.9 18.9 10 20 10C21.1 10 22 10.9 22 12C22 13.1 21.1 14 20 14C18.9 14 18 13.1 18 12Z" fill={color}/>
    <path d="M6.34 6.34C5.56 5.56 4.44 5.56 3.66 6.34C2.88 7.12 2.88 8.24 3.66 9.02C4.44 9.8 5.56 9.8 6.34 9.02C7.12 8.24 7.12 7.12 6.34 6.34Z" fill={color}/>
    <path d="M17.66 17.66C16.88 16.88 15.76 16.88 14.98 17.66C14.2 18.44 14.2 19.56 14.98 20.34C15.76 21.12 16.88 21.12 17.66 20.34C18.44 19.56 18.44 18.44 17.66 17.66Z" fill={color}/>
    <path d="M17.66 6.34C18.44 5.56 18.44 4.44 17.66 3.66C16.88 2.88 15.76 2.88 14.98 3.66C14.2 4.44 14.2 5.56 14.98 6.34C15.76 7.12 16.88 7.12 17.66 6.34Z" fill={color}/>
    <path d="M6.34 17.66C7.12 16.88 7.12 15.76 6.34 14.98C5.56 14.2 4.44 14.2 3.66 14.98C2.88 15.76 2.88 16.88 3.66 17.66C4.44 18.44 5.56 18.44 6.34 17.66Z" fill={color}/>
    <circle cx="12" cy="12" r="3" fill={color} opacity="0.3"/>
  </svg>
);

export const LeafIcon = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22L6.66 19.7C7.14 19.87 7.64 20 8 20C19 20 22 3 22 3C21 5 14 5.25 9 6.25C4 7.25 2 11.5 2 13.5C2 15.5 3.75 17.25 6 17.25C7.5 17.25 9 16.5 10 15.5C11 14.5 12 13 12 11.5C12 10 11 8.5 9.5 8.5C8.5 8.5 7.5 9 7 10C6.5 11 6.5 12 7 13C7.5 14 8.5 14.5 9.5 14.5C10.5 14.5 11.5 14 12 13C12.5 12 12.5 11 12 10C11.5 9 10.5 8.5 9.5 8.5Z" fill={color}/>
    <path d="M12 2C12.5 2.5 13 3 13 4C13 5 12.5 6 12 6.5C11.5 7 11 7 10.5 6.5C10 6 10 5 10.5 4C11 3 11.5 2.5 12 2Z" fill={color} opacity="0.6"/>
  </svg>
);

export const SeedIcon = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="12" rx="8" ry="4" fill={color} opacity="0.2"/>
    <ellipse cx="12" cy="12" rx="6" ry="3" fill={color} opacity="0.4"/>
    <ellipse cx="12" cy="12" rx="4" ry="2" fill={color}/>
    <circle cx="8" cy="8" r="1.5" fill={color} opacity="0.6"/>
    <circle cx="16" cy="8" r="1.5" fill={color} opacity="0.6"/>
    <circle cx="8" cy="16" r="1.5" fill={color} opacity="0.6"/>
    <circle cx="16" cy="16" r="1.5" fill={color} opacity="0.6"/>
    <circle cx="12" cy="6" r="1" fill={color} opacity="0.8"/>
    <circle cx="12" cy="18" r="1" fill={color} opacity="0.8"/>
    <circle cx="6" cy="12" r="1" fill={color} opacity="0.8"/>
    <circle cx="18" cy="12" r="1" fill={color} opacity="0.8"/>
  </svg>
);

export const RootIcon = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C13 2 14 3 14 4C14 5 13 6 12 6C11 6 10 5 10 4C10 3 11 2 12 2Z" fill={color}/>
    <path d="M8 6C9 6 10 7 10 8C10 9 9 10 8 10C7 10 6 9 6 8C6 7 7 6 8 6Z" fill={color}/>
    <path d="M16 6C17 6 18 7 18 8C18 9 17 10 16 10C15 10 14 9 14 8C14 7 15 6 16 6Z" fill={color}/>
    <path d="M6 10C7 10 8 11 8 12C8 13 7 14 6 14C5 14 4 13 4 12C4 11 5 10 6 10Z" fill={color}/>
    <path d="M18 10C19 10 20 11 20 12C20 13 19 14 18 14C17 14 16 13 16 12C16 11 17 10 18 10Z" fill={color}/>
    <path d="M10 14C11 14 12 15 12 16C12 17 11 18 10 18C9 18 8 17 8 16C8 15 9 14 10 14Z" fill={color}/>
    <path d="M14 14C15 14 16 15 16 16C16 17 15 18 14 18C13 18 12 17 12 16C12 15 13 14 14 14Z" fill={color}/>
    <path d="M12 18C13 18 14 19 14 20C14 21 13 22 12 22C11 22 10 21 10 20C10 19 11 18 12 18Z" fill={color}/>
    <path d="M4 8C5 8 6 9 6 10C6 11 5 12 4 12C3 12 2 11 2 10C2 9 3 8 4 8Z" fill={color} opacity="0.6"/>
    <path d="M20 8C21 8 22 9 22 10C22 11 21 12 20 12C19 12 18 11 18 10C18 9 19 8 20 8Z" fill={color} opacity="0.6"/>
    <path d="M4 16C5 16 6 17 6 18C6 19 5 20 4 20C3 20 2 19 2 18C2 17 3 16 4 16Z" fill={color} opacity="0.6"/>
    <path d="M20 16C21 16 22 17 22 18C22 19 21 20 20 20C19 20 18 19 18 18C18 17 19 16 20 16Z" fill={color} opacity="0.6"/>
  </svg>
);

// Icon mapping for categories
export const categoryIcons = {
  'Flowers': FlowerIcon,
  'Leaves': LeafIcon,
  'Seeds': SeedIcon,
  'Roots': RootIcon,
};

// Helper function to get icon component
export const getCategoryIcon = (categoryName) => {
  return categoryIcons[categoryName] || FlowerIcon;
};
